import React, { Component } from 'react';
import './App.css';
import listPerfProgs from './listPerfProgs';
import listProgs from './listProgs';
import WebAssemblyProg from "./WebAssemblyProg";
import ProgramForm from "./ProgramForm";
import JavascriptProg from "./JavascriptProg";

class App extends Component {

    constructor() {
        super();
        this.state = { currProgName: "" , newRun: false, speedUp: 0.0, count: 0, baseVal: 0.0, perfMode: true, writeMode: true};
        this.handleProgramChange = this.handleProgramChange.bind(this);
        this.jsReady = this.jsReady.bind(this);
        this.computationOver = this.computationOver.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.changeWriteMode = this.changeWriteMode.bind(this);
    }

    handleSelectChange(){
        this.setState({speedUp: 0.0, count: 0, baseVal: 0.0});
    }

    handleProgramChange(progName){
        this.setState({currProgName: progName, newRun: true, perfMode: true});
    }

    handleProgramChangeSimple(progName){
        this.setState({currProgName: progName, newRun: true, perfMode: false});
    }

    jsReady(value){
        this.setState({baseVal: value});
        if(this.state.perfMode) {
            this.jsProgram.run();
        }
    }

    computationOver(value){
        var speed = value !== 0 ? value/this.state.baseVal : this.state.baseVal;
        this.setState({speedUp: this.state.speedUp + speed, count: this.state.count +1});
    }

    changeWriteMode(){
        this.setState({writeMode: !this.state.writeMode});
        this.handleSelectChange();
    }

    componentDidUpdate(){
        if(this.state.newRun) {
            this.watProgram.run();
            this.setState({newRun: false});
        }
    }

  render() {
    return (
      <div className="App">
        <header className="App-header">
          <h1 className="App-title">Amy WebMode</h1>
        </header>
          <div className="wrapper">
              <div className="box c">
                  <h3 className="Block-title">>Amy WebAssembly performance</h3>
                  <br/>
                      {this.state.currProgName.length > 0 &&
                      <WebAssemblyProg
                          over={this.jsReady}
                          ref={(watP) => { this.watProgram = watP;}}
                          fileName={this.state.currProgName}
                          perfM={this.state.perfMode}
                          writeM={this.state.writeMode}
                      />}
            </div>
            <div className="box d">
                <h3 className="Block-title">>Javascript performance</h3>
                <br/>
                {this.state.currProgName.length > 0 &&
                <JavascriptProg
                    over={this.computationOver}
                    ref={(jsP) => { this.jsProgram = jsP;}}
                    fileName={this.state.currProgName}
                    perfM={this.state.perfMode}
                    writeM={this.state.writeMode}
                />}
            </div>
              <div className="box b">
                  <h3 className="box-Title">Performance evaluation</h3>
                  <div className="PerfListWrapper">
                      <ProgramForm
                          progNames={listPerfProgs}
                          handleSelect={() => this.handleSelectChange() }
                          callbackParent={(progName) => this.handleProgramChange(progName) }/>
                      <br />
                      <input id="chkbox" type="checkbox" defaultChecked={false} onChange={this.changeWriteMode}/>
                      <label className="check-text" htmlFor="chkbox">More accurate performance evaluation<br/>(No printing so that the programs stay unaffected by ReactJs state update)</label>
                      <br />
                      {this.state.count > 0 && <div>
                          <h2 className="Block-title">>Average Speed Up: {
                              this.state.speedUp/this.state.count} x.</h2>
                          <p className="Block-result">({this.state.count} samples)</p>
                      </div>
                      }
                  </div>
              </div>
              <div className="box e">
                  <h3 className="box-Title">WebAssembly programs</h3>
                  <div className="PerfListWrapper">
                      <ProgramForm
                          progNames={listProgs}
                          handleSelect={() => this.handleSelectChange() }
                          callbackParent={(progName) => this.handleProgramChangeSimple(progName) }/>
                  </div>
              </div>
          </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js